import { Component, Input, OnInit, inject } from "@angular/core";
import { IncidentConfigModel } from "@app/incident/models/incident-config.model";
import { IncidentService } from "@app/incident/services/incident.service";
import { BusinessNavigatorPermissionModel } from "@app/navigators/business-navigator/models/business-navigator-permission-model";
import { BusinessNavigatorRequestModel } from "@app/navigators/business-navigator/models/business-navigator-request-model";
import { NavigatorConfigType } from "@app/navigators/enums/NavigatorConfigType";
import { NavGenericListFactory } from "@app/navigators/services/NavGenericListFactory";
import { GenericListConfig } from "@app/shared/models/GenericList/GenericList";
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";
import moment from "moment";
import { map } from "rxjs";
import { GenericListManagerComponent } from "@app/shared/generic-managers/generic-list-manager/generic-list-manager.component";

@Component({
    selector: "business-incidents",
    templateUrl: "./business-incidents.component.html",
    imports: [GenericListManagerComponent],
})
export class BusinessIncidentsComponent implements OnInit {
    private _incidentsDs = inject(IncidentService);
    private _navFactory = inject(NavGenericListFactory);
    private _tabService = inject(TabService);
    private _pages = inject(Pages);

    @Input() requestModel: BusinessNavigatorRequestModel;
    @Input() permissionsModel: BusinessNavigatorPermissionModel;
    config: GenericListConfig;

    ngOnInit() {
        this.config = this._navFactory.createConfig(NavigatorConfigType.Incident);

        this.config.dataMethod = () => {
            var items = this._incidentsDs.getIncidentsForBusinessAssessment(this.requestModel).pipe(
                map((data) => {
                    data.forEach((item) => {
                        item.dateDetected = item.dateDetected
                            ? new Date(moment(item.dateDetected).format("YYYY-MM-DD"))
                            : null;
                    });
                    return data;
                })
            );
            return items;
        };

        this.config.hideRefreshButton = false;

        this.config.allowAdd = this.permissionsModel.canAddEvent;
        this.config.addOverride = () => {
            const config = <IncidentConfigModel>{
                organizationId: this.requestModel.organizationID,
                businessId: this.requestModel.businessID,
            };
            this._tabService.generateTab(this._pages.IncidentDetail, 0, "(I) New Incident", config);
        };
    }
}
